<template>
  <div class="wrapper">
    <transition name="fade">
      <p v-if="show">小飞棍来喽</p>
    </transition>
    <button @click="show = !show">切换</button>
    <son>
      <template #title>
        <h1>头铁</h1>
      </template>
      <template #end>
        <h1>gg</h1>
      </template>
      <template>
        <h1>无名氏好惨</h1>
      </template>
    </son>
  </div>
</template>

<script>
import son from "@/components/son.vue"
export default {
  components: {
    son
  },
  data() {
    return {
      show: false
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  .fade-enter-active, .fade-leave-active {
    transition: all 3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
    width:100px;
  }
  p{
    border:1px solid red;
    width:300px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/user/jiushiwan.vue